export default __webpack_public_path__ + "static/girl_in_app-a6a19638d44b4ca1f0e9102224fe5e50.png";